import './Full-Screen.svelte.css.proxy.js';
/* src/components/Full-Screen.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_element,
	claim_space,
	claim_text,
	create_slot,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_slot
} from "../_snowpack/pkg/svelte/internal.js";

import {
	setQueryParamWithHistory,
	deleteQueryParam,
	getQueryParam
} from "../_helpers/window-helper.js";

import { onMount } from "../_snowpack/pkg/svelte.js";

function create_else_block(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[5].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[4], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		l(nodes) {
			if (default_slot) default_slot.l(nodes);
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 16) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[4], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (61:2) {#if reload}
function create_if_block(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[5].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[4], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		l(nodes) {
			if (default_slot) default_slot.l(nodes);
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 16) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[4], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let t0;
	let button;
	let t1;
	let current;
	let mounted;
	let dispose;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*reload*/ ctx[1]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			t0 = space();
			button = element("button");
			t1 = text("FULL SCREEN MODE");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if_block.l(div_nodes);
			div_nodes.forEach(detach);
			t0 = claim_space(nodes);
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t1 = claim_text(button_nodes, "FULL SCREEN MODE");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "fullscreen-wrapper svelte-1fqdder");
			toggle_class(div, "overlay", /*overlay*/ ctx[0]);
			attr(button, "class", "overlay-button svelte-1fqdder");
			toggle_class(button, "overlay", /*overlay*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			insert(target, t0, anchor);
			insert(target, button, anchor);
			append(button, t1);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*toggleFullScreen*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}

			if (dirty & /*overlay*/ 1) {
				toggle_class(div, "overlay", /*overlay*/ ctx[0]);
			}

			if (dirty & /*overlay*/ 1) {
				toggle_class(button, "overlay", /*overlay*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
			if (detaching) detach(t0);
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { reloadSlotOnToggle = true } = $$props;

	onMount(() => {
		$$invalidate(0, overlay = getQueryParam("full-screen") == "1");

		window.addEventListener("popstate", event => {
			// console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
			$$invalidate(0, overlay = getQueryParam("full-screen") == "1");
		});
	});

	let overlay = false;
	let reload = false;

	function toggleFullScreen() {
		$$invalidate(0, overlay = !overlay);

		if (overlay) {
			setQueryParamWithHistory("full-screen", "1");
		} else {
			deleteQueryParam("full-screen");
		}

		if (reloadSlotOnToggle) {
			$$invalidate(1, reload = !reload);
		}
	}

	$$self.$$set = $$props => {
		if ("reloadSlotOnToggle" in $$props) $$invalidate(3, reloadSlotOnToggle = $$props.reloadSlotOnToggle);
		if ("$$scope" in $$props) $$invalidate(4, $$scope = $$props.$$scope);
	};

	return [overlay, reload, toggleFullScreen, reloadSlotOnToggle, $$scope, slots];
}

class Full_Screen extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { reloadSlotOnToggle: 3 });
	}
}

export default Full_Screen;
//# sourceMappingURL=Full-Screen.svelte.js.map
